<template>
  <div v-if="pictures && pictures.length" class="fs14 flex-start" :class="{[params.className]: !!params.className}">
    <p class="c0-5 w70 textRight mr8">{{params.label}}:</p>
    <div class="c0-65">
     <span v-if="previewSrcList.length>0">
      <template v-for="(item, index) in previewSrcList">
        <el-image
          :key="index"
          style="width: 6.25rem; height: 6.25rem;margin-right:0.625rem;"
          :src="item"
          :preview-src-list="previewSrcList">
        </el-image>
      </template>
    </span>
    <span v-else>
      <el-image
        style="width: 6.25rem; height: 6.25rem;margin-right:0.625rem"
        :src="require('@/assets/zanwu.png')">
      </el-image>
    </span>
    </div>
  </div>
</template>

<script>
import { filterMiImage } from '@/utils/tools'

export default {
  name: 'v-image',
  props: ['params', 'rowData'],
  computed: {
    pictures() {
      if (this.rowData && this.rowData[this.params.key || 'pictures']) {
        let ps = this.rowData[this.params.key || 'pictures']
        if (Array.isArray(ps)) {
          return ps
        } else if (typeof ps === 'string') {
          ps = this.rowData[this.params.key || 'pictures'].split(',')
          return ps
        }
        return ''
      }
      return ''
    },
    previewSrcList() {
      return this.pictures.map(item => filterMiImage(item)).filter(item => {
        // 过滤条件：非空字符串、且不是纯空格
        return item && item.trim() !== ''
      })
    }
  },
  methods: {
    filterMiImage(url) {
      return filterMiImage(url)
    }
  }
}
</script>

<style lang="less">
@import "../../../styles/index.less";
</style>
